
<div [ngClass]="rightSlideClasses">
    <p-card>
    <p-tabView [(activeIndex)]="tabIndex">
        <p-tabPanel>
            <ng-template pTemplate="header">
                <i class="pi pi-phone"></i>
                <span>Phone</span>
            </ng-template>
            <iframe *ngIf="!isAdminUser()" src="https://hemicallrouting-2700.twil.io/workerStatus"></iframe>
            <iframe *ngIf="isAdminUser()" src="https://hemicallrouting-2700.twil.io/workerStatus?admin=Y"></iframe>
        </p-tabPanel>
        <p-tabPanel>
            <ng-template pTemplate="header">
                <i class="pi pi-comment"></i>
                <span>Chat</span>
            </ng-template>
            <div *ngIf="chatActive" class="flex w-full flex-column">
                <div class="w-full">
                    <iframe  class="iframe" [src]="chatUrlSafe"></iframe>
                </div>
                <div class="flex w-full justify-content-center">
                    <p-button label="End Chat" (click)="endCurrentTask()"></p-button>
                </div>
            </div>
            <div *ngIf="!chatActive" class="grid fill-vert">
                <div class="col-12 flex justify-content-center align-items-center">
                    <span>No Active Chat</span>
                </div>
            </div>
        </p-tabPanel>
        <p-tabPanel>
            <ng-template pTemplate="header">
                <i class="pi pi-book"></i>
                <span>Diaries</span>
            </ng-template>
            <iframe *ngIf="betaActive" class="fw-iframe" [src]="diaryManagerUrlSafe" loading="lazy" allow="clipboard-read; clipboard-write"></iframe>
            <app-diary-scroller *ngIf="!betaActive" [allowNew]="false" [getForCurrentUser]="true" [showReferenceLinks]="true" (loadDiaryReference)="loadEntityFromDiary($event)" [allowStatusSelection]="false"></app-diary-scroller>
        </p-tabPanel>
    </p-tabView>
    </p-card>
    <div >
        <button pButton type="button" (click)="togglePhone()" icon="pi pi-phone" class="right-slider-phone-button" ></button>
        <button pButton type="button" (click)="toggleChat()" icon="pi pi-comment" class="right-slider-chat-button" ></button>
        <button pButton type="button" (click)="toggleDiary()" icon="pi pi-book" class="right-slider-diary-button" ></button>
    </div>
</div>